import type { AppDefinition } from '../../types/apps';

export const PageAppV2Definition: AppDefinition = {
  appId: 'page-v2',
  name: 'Page',
  version: '2.0.0',
  description: 'Notion-style pages with tasks, buttons, embeds, and rich content.',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'Article',
    phosphorWeight: 'duotone',
  },
  component: 'PageApp_v2',
  entityTypes: ['Page'],
  requiresProps: false,
  requiresEntity: true,
};

export const pageAppV2Definition = {
  id: 'page-v2',
  name: 'Page',
  description: 'Notion-style pages with tasks, buttons, embeds, and rich content',
  version: '2.0.0',

  entityTypes: ['Page'],

  requiresVersion: 'v2',

  features: {
    collaboration: true,
    aiCommands: true,
    tasks: true,
    embeds: true,
    actionButtons: true,
    export: true,
    offline: true,
    markdownMode: true,
    blockEditor: 'prosemirror' as const,
  },

  icon: '📄',
  color: '#6366F1',

  supportsCommands: [
    'entity_read',
    'entity_write',
    'page_create',
  ],
};

export default pageAppV2Definition;
